<template>
  <div>
    <Master>
      <template v-slot:home>
        <div class="container custom_width black">
          <nav class="text-center navbartop">
            <a class="navbar-brand custom_color fixx float-left" href="#">
              <span class="line1"></span>
              <span class="line2"></span>
              <span class="line3"></span>
            </a>
            <span class="toptext">
              <span class="title"
                >Pick Up

                <span class="lan"
                  ><a href="" class="active">JA</a> / <a href="">EN</a></span
                >
              </span>
            </span>

            <div class="lines">&nbsp;</div>
          </nav>
          <div>
            <div class="col-md-12">
              <div class="lists_img">
                <div class="single">
                  <div class="row">
                    <div class="col-md-3 col-4">
                      <img
                        class="w100"
                         src="@/assets/images/im1.png"
                        alt=""
                      />
                    </div>
                    <div class="col-md-9 col-8 info">
                      <span class="date">2020/10/10 </span>
                      <p>
                        日本初、ブロックチェーン技術を活用したストックオプション「J-STOSO」を発行
                      </p>
                    </div>
                  </div>
                </div>
                <div class="single">
                  <div class="row">
                    <div class="col-md-3 col-4">
                      <img
                        class="w100"
                        src="@/assets/images/im2.png"
                      />
                    </div>
                    <div class="col-md-9 col-8 info">
                      <span class="date">2020/10/10 </span>
                      <p>
                        レヴィアス株式会社、ジブラルタル証券取引所とMOU締結による業務提携を発表
                      </p>
                    </div>
                  </div>
                </div>
                <div class="single">
                  <div class="row">
                    <div class="col-md-3 col-4">
                      <img
                        class="w100"
                        src="@/assets/images/im3.png"
                      />
                    </div>
                    <div class="col-md-9 col-8 info">
                      <span class="date">2020/10/10 </span>
                      <p>
                        日本初、当社開発技術によるセキュリティト－クンを通じた資産の譲渡（セカンダリ取引）が実現
                      </p>
                    </div>
                  </div>
                </div>
                <div class="single">
                  <div class="row">
                    <div class="col-md-3 col-4">
                      <img
                        class="w100"
                        src="@/assets/images/im4.png"
                      />
                    </div>
                    <div class="col-md-9 col-8 info">
                      <span class="date">2020/10/10 </span>
                      <p>日本初、J-STO Equity による資金調達を完了</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center custom_margin_nxt">
            <a href="form.html" class="btn btn-next" @click.prevent="nextStep"
              >アカウント登録
            </a>
          </div>
        </div>
      </template>
    </Master>
  </div>
</template>

<script>
import Master from "../layouts/Master";

export default {
  name: "Home",
  components: {
    Master,
  },
  methods: {
    nextStep() {
      // this.$router.push({
      //   path: "/personal-information",
      // });
       window.location.href = `https://register.ekyc.vwall.co.jp`;
    },
  },
};
</script>

<style scoped>
</style>